import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "./components/layout/Layout";
import { ThemeProvider } from "./context/ThemeContext";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import PolicyCenter from "./pages/PolicyCenter";
import ClaimCenter from "./pages/ClaimCenter";
import BillingCenter from "./pages/BillingCenter";
import CloudModernisation from "./pages/CloudModernisation";
import QATesting from "./pages/QATesting";
import Staffing from "./pages/Staffing";
import CaseStudies from "./pages/CaseStudies";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/policycenter" element={<PolicyCenter />} />
                <Route path="/services/claimcenter" element={<ClaimCenter />} />
                <Route path="/services/billingcenter" element={<BillingCenter />} />
                <Route path="/cloud-modernisation" element={<CloudModernisation />} />
                <Route path="/qa-testing" element={<QATesting />} />
                <Route path="/staffing" element={<Staffing />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
